import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { objectFitCoverImageStyles, SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
var HEADER_HEIGHT = 300;
export var SDUIHeaderRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var headerComponent = component.header_component;
    if (!headerComponent) {
        return null;
    }
    var tagline = headerComponent.tagline, title = headerComponent.title, sub_title = headerComponent.sub_title, button_list = headerComponent.button_list, responsive_background_image = headerComponent.responsive_background_image;
    var clientResponsiveImage = convertServerResponsivePropertyToClientResponsiveProperty(IImage.build(), function(img) {
        return img;
    }, responsive_background_image);
    return /*#__PURE__*/ _jsxs(Flex, {
        direction: {
            mobileAndAbove: "column",
            desktopAndAbove: "row"
        },
        align: {
            mobileAndAbove: "start",
            desktopAndAbove: "center"
        },
        className: "relative justify-between gap-y-4 w-full overflow-hidden",
        children: [
            /*#__PURE__*/ _jsx(SDUIImage, {
                responsiveImage: clientResponsiveImage,
                optimizeImageOptions: {
                    height: HEADER_HEIGHT
                },
                showPlaceholder: false,
                renderBehaviour: renderBehaviour,
                className: "absolute top-0 left-0 w-full h-full z-0",
                imageStyles: objectFitCoverImageStyles
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: "1x",
                className: "flex-grow-0 flex-shrink basis-full w-full lg:w-auto z-[1]",
                children: [
                    tagline ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: tagline,
                        loggingData: loggingData
                    }) : null,
                    title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: title,
                        loggingData: loggingData
                    }) : null,
                    sub_title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: sub_title,
                        loggingData: loggingData
                    }) : null
                ]
            }),
            button_list.length > 0 ? /*#__PURE__*/ _jsx(Row, {
                gap: "1x",
                className: "flex-grow flex-shrink-0 basis-auto",
                children: button_list.map(function(buttonElement, i) {
                    var _buttonElement_logging_data;
                    return /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                        loggingData: loggingData,
                        buttonElement: buttonElement
                    }, "".concat(i, "-").concat((_buttonElement_logging_data = buttonElement.logging_data) === null || _buttonElement_logging_data === void 0 ? void 0 : _buttonElement_logging_data.instance_identifier));
                })
            }) : null
        ]
    });
};
